package com.kaihuoy.home.screens

import androidx.compose.runtime.*
import com.kaihuoy.components.common.AppStyles
import kotlinx.browser.window
import kotlinx.coroutines.launch
import kotlin.js.Date
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.shared.data.*
import com.kaihuoy.web.FirebaseService
import com.kaihuoy.components.common.*
import com.kaihuoy.components.common.*
import com.kaihuoy.web.router.AppRouterState

@Composable
fun AdminScreen(user: User?, isAdmin: Boolean, onLogout: () -> Unit, accentHex: String) {
    val isMobile = window.innerWidth <= 900
    var selectedTab by remember { mutableStateOf("inductions") }
    var vastaukset by remember { mutableStateOf<List<PerehdytysVastaus>>(emptyList()) }
    var filterTyomaa by remember { mutableStateOf("") }
    var inspections by remember { mutableStateOf<List<InspectionRecord>>(emptyList()) }
    var announcements by remember { mutableStateOf<List<Announcement>>(emptyList()) }
    var filterPainekoeUser by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(true) }
    var selectedVastaus by remember { mutableStateOf<PerehdytysVastaus?>(null) }
    var selectedInspection by remember { mutableStateOf<InspectionRecord?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(user?.uid, isAdmin) {
        val uid = user?.uid ?: run {
            vastaukset = emptyList()
            inspections = emptyList()
            isLoading = false
            return@LaunchedEffect
        }

        isLoading = true
        launch {
            try {
                val vastausQuery = if (isAdmin) {
                    FirebaseService.database.reference("perehdytys_vastaukset")
                } else {
                    FirebaseService.database.reference("perehdytys_vastaukset").orderByChild("userId").equalTo(uid)
                }

                vastausQuery.valueEvents.collect { snapshot ->
                    vastaukset = snapshot.children.mapNotNull { child ->
                        try {
                            val record = child.value<PerehdytysVastaus>()
                            if (record.id.isBlank()) record.copy(id = child.key ?: "") else record
                        } catch (e: Exception) {
                            console.error("Virhe perehdytysvastauksen luvussa: ${child.key}", e)
                            null
                        }
                    }.sortedByDescending { it.aika }

                    selectedVastaus?.let { current ->
                        selectedVastaus = vastaukset.find { it.id == current.id }
                    }
                }
            } catch (e: kotlinx.coroutines.CancellationException) {
                throw e
            } catch (e: Exception) {
                console.error("Perehdytysvastusten haku epäonnistui", e)
            }
        }

        launch {
            try {
                val inspectionQuery = if (isAdmin) {
                    FirebaseService.database.reference("inspections")
                } else {
                    FirebaseService.database.reference("inspections").orderByChild("userId").equalTo(uid)
                }

                inspectionQuery.valueEvents.collect { inspSnapshot ->
                    inspections = inspSnapshot.children.mapNotNull { child ->
                        try {
                            val record = child.value<InspectionRecord>()
                            if (record.id.isBlank()) record.copy(id = child.key ?: "") else record
                        } catch (e: Exception) {
                            console.error("Virhe tarkastuksen luvussa: ${child.key}", e)
                            null
                        }
                    }.sortedByDescending { it.timestamp }

                    selectedInspection?.let { current ->
                        selectedInspection = inspections.find { it.id == current.id }
                    }
                    isLoading = false
                }
            } catch (e: kotlinx.coroutines.CancellationException) {
                throw e
            } catch (e: Exception) {
                console.error("Tarkastusten haku epäonnistui", e)
                isLoading = false
            }
        }

        if (isAdmin) {
            launch {
                try {
                    FirebaseService.database.reference("announcements").valueEvents.collect { announcementSnapshot ->
                        announcements = announcementSnapshot.children.mapNotNull { child ->
                            try {
                                val record = child.value<Announcement>()
                                if (record.id.isBlank()) record.copy(id = child.key ?: "") else record
                            } catch (e: Exception) {
                                console.error("Virhe ilmoituksen luvussa: ${child.key}", e)
                                null
                            }
                        }
                            .sortedWith(compareByDescending<Announcement> { it.isPinned }.thenByDescending { it.timestamp })
                    }
                } catch (e: kotlinx.coroutines.CancellationException) {
                    throw e
                } catch (e: Exception) {
                    console.error("Ilmoitusten haku epäonnistui", e)
                }
            }
        }
    }
    PageLayout(greeting = getGreeting(user?.displayName), onLogout = onLogout) {
        Div(attrs = {
            style {
                padding(32.px)
                // maxWidth(1200.px)  ← poista tai kasvata
                // property("margin", "0 auto")  ← poista
                boxSizing("border-box")
                width(100.percent)


            }
        }) {
            H1(attrs = { classes("no-print") }) { Text(if (isAdmin) "Hallinta" else "Omat kirjaukset") }

            // Välilehdet
            Div(attrs = {
                classes("no-print")
                style {
                    display(if (isMobile) DisplayStyle.Grid else DisplayStyle.Flex)
                    gap(8.px)
                    marginBottom(32.px)
                    backgroundColor(KaihuTheme.Divider)
                    padding(4.px)
                    borderRadius(12.px)
                    property("width", if (isMobile) "100%" else "fit-content")
                    property("overflow-x", "auto")
                    property("overflow-y", "hidden")
                    if (isMobile) {
                        property("grid-template-columns", "repeat(2, minmax(0, 1fr))")
                    } else {
                        flexWrap(FlexWrap.Nowrap)

                    }
                    boxSizing("border-box")
                }
            }) {
                TabItem(
                    "Perehdytykset",
                    "clipboard-list",
                    selectedTab == "inductions",
                    isMobile,
                    isNoPrint = true
                ) { selectedTab = "inductions"; selectedVastaus = null }
                TabItem(
                    "Tarkastukset",
                    "tool",
                    selectedTab == "inspections",
                    isMobile,
                    isNoPrint = true
                ) { selectedTab = "inspections"; selectedInspection = null }
                if (isAdmin) {
                    TabItem(
                        "Ilmoitukset",
                        "speakerphone",
                        selectedTab == "announcements",
                        isMobile,
                        isNoPrint = true
                    ) { selectedTab = "announcements" }
                    TabItem("Käyttäjät", "users", selectedTab == "users", isMobile, isNoPrint = true) {
                        selectedTab = "users"
                    }
                    TabItem("Koneet", "tractor", selectedTab == "machines", isMobile, isNoPrint = true) {
                        selectedTab = "machines"
                    }
                    TabItem(
                        "Työmaat",
                        "building-factory",
                        selectedTab == "tyomaat",
                        isMobile,
                        isNoPrint = true
                    ) { selectedTab = "tyomaat" }
                    TabItem("Kuormat", "package", selectedTab == "kuormat", isMobile, isNoPrint = true) {
                        selectedTab = "kuormat"
                    }
                    TabItem("Painekokeet", "droplet", selectedTab == "painekokeet", isMobile, isNoPrint = true) {
                        selectedTab = "painekokeet"
                    }
                }
            }

            if (isLoading) {
                P { Text("Ladataan...") }
            } else {
                when (selectedTab) {
                    "inductions", "inspections" -> {
                        Div(attrs = {
                            style {
                                display(DisplayStyle.Flex)
                                flexDirection(if (isMobile) FlexDirection.Column else FlexDirection.Row)
                                gap(32.px)
                                alignItems(AlignItems.FlexStart)
                            }
                        }) {
                            // Vasen puoli: Lista
                            Div(attrs = {
                                classes("no-print")
                                style {
                                    flex("1")
                                    width(100.percent)
                                    if (!isMobile && (selectedVastaus != null || selectedInspection != null)) {
                                        maxWidth(400.px)
                                    }
                                    property("transition", "all 0.3s ease")
                                }
                            }) {
                                if (selectedTab == "inductions") {
                                    val tyomaaOptions = remember(vastaukset) {
                                        listOf(DropdownOption("", "Kaikki työmaat")) +
                                                vastaukset.mapNotNull { it.tyomaa.takeIf { t -> t.isNotBlank() } }
                                                    .distinct().sorted().map { DropdownOption(it, it) }
                                    }
                                    val filtered = remember(vastaukset, filterTyomaa) {
                                        if (filterTyomaa.isEmpty()) vastaukset
                                        else vastaukset.filter { it.tyomaa == filterTyomaa }
                                    }

                                    StyledDropdown(
                                        value = filterTyomaa,
                                        options = tyomaaOptions,
                                        placeholder = "Kaikki työmaat",
                                        label = "Työmaa",
                                        onSelect = { filterTyomaa = it; selectedVastaus = null }
                                    )
                                    Div(attrs = { style { marginBottom(12.px) } }) {
                                        Span(attrs = { style { fontSize(0.82.em); color(KaihuTheme.TextSecondary) } }) {
                                            Text("${filtered.size} / ${vastaukset.size} perehdytystä")
                                        }
                                    }

                                    if (filtered.isEmpty()) P(attrs = { style { color(KaihuTheme.TextSecondary) } }) {
                                        Text(if (filterTyomaa.isNotEmpty()) "Ei perehdytyksiä valitulla työmaalla." else "Ei perehdytysvastauksia.")
                                    }
                                    filtered.forEach { record ->
                                        PerehdytysVastausItem(
                                            record = record,
                                            isAdmin = isAdmin,
                                            isSelected = selectedVastaus?.id == record.id,
                                            onClick = {
                                                selectedVastaus = record
                                                selectedInspection = null
                                            },
                                            onDelete = {
                                                com.kaihuoy.components.common.AppFeedback.confirm(
                                                    "Poistetaanko perehdytys?",
                                                    "Poistetaanko ${record.userName}:n vastaukset pohjaasta \"${record.pohjaOtsikko}\"?",
                                                    "Poista",
                                                    confirmColor = KaihuTheme.Danger
                                                ) {
                                                    scope.launch {
                                                        try {
                                                            FirebaseService.database.reference("perehdytys_vastaukset")
                                                                .child(record.id).removeValue()
                                                            if (selectedVastaus?.id == record.id) selectedVastaus = null
                                                            com.kaihuoy.components.common.AppFeedback.showSuccess("Poistettu")
                                                        } catch (e: Exception) {
                                                            com.kaihuoy.components.common.AppFeedback.showError("Poisto epäonnistui")
                                                        }
                                                    }
                                                }
                                            }
                                        )
                                    }
                                } else if (selectedTab == "inspections") {
                                    if (inspections.isEmpty()) P { Text("Ei tarkastuksia.") }
                                    inspections.forEach { record ->
                                        InspectionRecordItem(
                                            record = record,
                                            isAdmin = isAdmin,
                                            isSelected = selectedInspection?.id == record.id,
                                            onClick = {
                                                selectedInspection = record
                                                selectedVastaus = null
                                            },
                                            onDelete = { /* collect hoitaa */ }
                                        )
                                    }
                                }
                            }

                            // Oikea puoli: Details
                            if (selectedVastaus != null || selectedInspection != null) {
                                Div(attrs = {
                                    classes("print-container")
                                    style {
                                        flex("2")
                                        width(100.percent)
                                        if (!isMobile) {
                                            property("position", "sticky")
                                            top(20.px)
                                        }
                                        property(
                                            "@media print",
                                            "position: static !important; top: 0 !important; width: 100% !important; display: block !important;"
                                        )
                                    }
                                }) {
                                    if (selectedTab == "inductions" && selectedVastaus != null) {
                                        PerehdytysVastausDetails(selectedVastaus!!)
                                    } else if (selectedTab == "inspections" && selectedInspection != null) {
                                        InspectionRecordDetails(selectedInspection!!)
                                    }
                                }
                            } else {
                                Div(attrs = {
                                    style {
                                        flex("2")
                                        width(100.percent)
                                        display(DisplayStyle.Flex)
                                        flexDirection(FlexDirection.Column)
                                        alignItems(AlignItems.Center)
                                        justifyContent(JustifyContent.Center)
                                        padding(if (isMobile) 28.px else 64.px)
                                        backgroundColor(KaihuTheme.Divider)
                                        borderRadius(24.px)
                                        border(1.px, LineStyle.Dashed, KaihuTheme.Border)
                                        color(KaihuTheme.TextLight)
                                    }
                                }) {
                                    Span(attrs = { style { fontSize(3.em); marginBottom(16.px) } }) {
                                        TIcon(
                                            "file",
                                            3.em
                                        )
                                    }
                                    P { Text("Valitse kirjaus listasta nähdäksesi tiedot") }
                                }
                            }
                        }
                    }

                    "users" -> {
                        var showAddUser by remember { mutableStateOf(false) }
                        if (showAddUser) {
                            com.kaihuoy.home.screens.AddUserScreen(onBack = { showAddUser = false })
                        } else {
                            Div(attrs = {
                                style {
                                    marginBottom(24.px); display(DisplayStyle.Flex); justifyContent(if (isMobile) JustifyContent.FlexStart else JustifyContent.FlexEnd); maxWidth(
                                    1400.px
                                )
                                }
                            }) {
                                StyledButton(
                                    "Lisää uusi käyttäjä",
                                    icon = "plus",
                                    onClick = { showAddUser = true },
                                    backgroundColor = KaihuTheme.Green
                                )
                            }
                            com.kaihuoy.home.screens.AllUsersScreen()
                        }
                    }

                    "announcements" -> {
                        AnnouncementAdminPanel(user = user, announcements = announcements)
                    }

                    "machines" -> {
                        com.kaihuoy.home.screens.MachineScreen(user, isAdmin, standalone = false, onLogout = onLogout)
                    }

                    "tyomaat" -> {
                        TyomaatAdminTab(user)
                    }

                    "kuormat" -> {
                        KuormatAdminTab()
                    }

                    "painekokeet" -> {
                        PainekoeAdminTab()
                    }
                }
            }
        }
    }
}

@Composable
private fun AnnouncementAdminPanel(user: User?, announcements: List<Announcement>) {
    val isMobile = window.innerWidth <= 900
    val scope = rememberCoroutineScope()
    val now = Date.now().toLong()
    val activeAnnouncements = announcements
        .filter { !isAnnouncementArchived(it, now) }
        .sortedWith(compareByDescending<Announcement> { it.isPinned }.thenByDescending { announcementSortTime(it) })
    val archivedAnnouncements = announcements
        .filter { isAnnouncementArchived(it, now) }
        .sortedByDescending { announcementSortTime(it) }

    var title by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    var publishPinned by remember { mutableStateOf(false) }
    var isSaving by remember { mutableStateOf(false) }
    var busyAnnouncementId by remember { mutableStateOf<String?>(null) }
    var editingAnnouncementId by remember { mutableStateOf<String?>(null) }

    val editingAnnouncement = announcements.firstOrNull { it.id == editingAnnouncementId }

    Div(attrs = {
        style {
            display(if (isMobile) DisplayStyle.Flex else DisplayStyle.Grid)
            if (isMobile) {
                flexDirection(FlexDirection.Column)
            } else {
                property("grid-template-columns", "minmax(320px, 420px) minmax(0, 1fr)")
            }
            gap(24.px)
            alignItems(AlignItems.Start)
        }
    }) {
        Div(attrs = {
            classes(AppStyles.cardShadow)
            style {
                property("background", KaihuTheme.CardGradient)
                borderRadius(24.px)
                padding(if (isMobile) 20.px else 28.px)
                property("box-shadow", AppStyles.cardShadow)
                property("border", "1px solid ${KaihuTheme.Divider}")
                boxSizing("border-box")
            }
        }) {
            H3(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                Text(if (editingAnnouncement != null) "Muokkaa ilmoitusta" else "Julkaise uusi ilmoitus")
            }
            P(attrs = { style { margin(0.px, 0.px, 20.px, 0.px); color(KaihuTheme.TextSecondary) } }) {
                Text(
                    if (editingAnnouncement != null) {
                        "Tallennus päivittää ilmoituksen sisällön ja asettaa sille uuden 2 viikon voimassaoloajan tästä hetkestä."
                    } else {
                        "Ilmoitukset näkyvät etusivulla kaikille käyttäjille. Uusi ilmoitus on oletuksena voimassa 2 viikkoa julkaisuhetkestä, jonka jälkeen se siirtyy arkistoituihin ilmoituksiin."
                    }
                )
            }

            StyledInput(
                label = "Otsikko",
                value = title,
                onValueChange = { title = it },
                placeholder = "Esim. Työmaa suljettu perjantaina klo 14 jälkeen"
            )

            StyledLargeInput(
                label = "Viesti",
                value = message,
                onValueChange = { message = it },
                placeholder = "Kirjoita ilmoituksen sisältö tähän"
            )

            /*Div(attrs = { style { marginBottom(18.px) } }) {
                Label(attrs = {
                    style {
                        display(DisplayStyle.Block)
                        marginBottom(8.px)
                        fontWeight("600")
                        color(KaihuTheme.TextPrimary)
                    }
                }) {
                    Text("Viesti")
                }
                TextArea(message, attrs = {
                    onInput { message = it.value }
                    placeholder("Kirjoita ilmoituksen sisältö tähän")
                    style {
                        width(100.percent)
                        minHeight(180.px)
                        padding(14.px, 16.px)
                        borderRadius(14.px)
                        border(1.px, LineStyle.Solid, KaihuTheme.Border)
                        fontSize(1.em)
                        fontFamily("inherit")
                        property("resize", "vertical")
                        boxSizing("border-box")
                        color(KaihuTheme.TextPrimary)
                    }
                })
            }*/

            StyledCheckbox(
                label = "Kiinnitä etusivun pääilmoitukseksi",
                checked = publishPinned,
                onCheckedChange = { publishPinned = it }
            )

            Div(attrs = { style { marginTop(20.px) } }) {
                Div(attrs = { style { display(DisplayStyle.Flex); gap(12.px); flexWrap(FlexWrap.Wrap) } }) {
                    StyledButton(
                        text = if (isSaving) {
                            if (editingAnnouncement != null) "Tallennetaan..." else "Julkaistaan..."
                        } else {
                            if (editingAnnouncement != null) "Tallenna muutokset" else "Julkaise ilmoitus"
                        },
                        enabled = !isSaving,
                        backgroundColor = KaihuTheme.Green,
                        onClick = {
                            val trimmedTitle = title.trim()
                            val trimmedMessage = message.trim()

                            if (trimmedTitle.isBlank()) {
                                com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksella pitää olla otsikko.")
                                return@StyledButton
                            }
                            if (trimmedMessage.isBlank()) {
                                com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen sisältö ei voi olla tyhjä.")
                                return@StyledButton
                            }

                            isSaving = true
                            scope.launch {
                                try {
                                    val currentTime = Date.now().toLong()
                                    val expiresAt = defaultAnnouncementExpiresAt(currentTime)

                                    if (publishPinned) {
                                        clearPinnedAnnouncements(announcements, excludeId = editingAnnouncement?.id)
                                    }

                                    if (editingAnnouncement != null) {
                                        FirebaseService.database.reference("announcements").child(editingAnnouncement.id).setValue(
                                            editingAnnouncement.copy(
                                                title = trimmedTitle,
                                                message = trimmedMessage,
                                                isPinned = publishPinned,
                                                isActive = true,
                                                isArchived = false,
                                                expiresAt = expiresAt,
                                                updatedAt = currentTime
                                            )
                                        )
                                        com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus päivitettiin. Voimassaoloaika jatkuu 2 viikkoa tästä hetkestä.")
                                    } else {
                                        val newRef = FirebaseService.database.reference("announcements").push()
                                        val newId = newRef.key ?: Date.now().toString()

                                        newRef.setValue(
                                            Announcement(
                                                id = newId,
                                                title = trimmedTitle,
                                                message = trimmedMessage,
                                                createdByName = user?.displayName?.ifBlank { user.email } ?: "Admin",
                                                userId = user?.uid ?: "",
                                                isPinned = publishPinned,
                                                isActive = true,
                                                timestamp = currentTime,
                                                expiresAt = expiresAt,
                                                isArchived = false,
                                                updatedAt = currentTime
                                            )
                                        )
                                        com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus julkaistiin.")
                                    }

                                    title = ""
                                    message = ""
                                    publishPinned = false
                                    editingAnnouncementId = null
                                } catch (e: Exception) {
                                    console.error("Ilmoituksen tallennus epäonnistui", e)
                                    com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen tallennus epäonnistui.")
                                } finally {
                                    isSaving = false
                                }
                            }
                        }
                    )

                    if (editingAnnouncement != null) {
                        StyledButton(
                            text = "Peruuta muokkaus",
                            enabled = !isSaving,
                            backgroundColor = KaihuTheme.Grey,
                            onClick = {
                                title = ""
                                message = ""
                                publishPinned = false
                                editingAnnouncementId = null
                            }
                        )
                    }
                }
            }
        }

        Div(attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(24.px)
            }
        }) {
            Div(attrs = {
                classes(AppStyles.cardShadow)
                style {
                    property("background", KaihuTheme.CardGradient)
                    borderRadius(24.px)
                    padding(if (isMobile) 20.px else 28.px)
                    property("box-shadow", AppStyles.cardShadow)
                    property("border", "1px solid ${KaihuTheme.Divider}")
                    boxSizing("border-box")
                }
            }) {
                H3(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                    Text("Aktiiviset ilmoitukset")
                }
                P(attrs = { style { margin(0.px, 0.px, 20.px, 0.px); color(KaihuTheme.TextSecondary) } }) {
                    Text("Aktiiviset ilmoitukset näkyvät etusivulla niin kauan kuin niiden 2 viikon voimassaoloaika on käynnissä tai kunnes arkistoit ne itse.")
                }

                if (activeAnnouncements.isEmpty()) {
                    P(attrs = { style { color(KaihuTheme.TextSecondary); margin(0.px) } }) {
                        Text("Ei aktiivisia ilmoituksia.")
                    }
                } else {
                    activeAnnouncements.forEach { announcement ->
                        val isBusy = busyAnnouncementId == announcement.id

                        Div(attrs = {
                            style {
                                padding(18.px, 0.px)
                                property("border-top", "1px solid ${KaihuTheme.Divider}")
                            }
                        }) {
                            Div(attrs = {
                                style {
                                    display(DisplayStyle.Flex)
                                    justifyContent(JustifyContent.SpaceBetween)
                                    alignItems(AlignItems.FlexStart)
                                    gap(16.px)
                                    flexWrap(FlexWrap.Wrap)
                                }
                            }) {
                                Div(attrs = { style { flex("1") } }) {
                                    AnnouncementStatusBadges(announcement, isArchived = false)

                                    H4(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                                        Text(announcement.title)
                                    }
                                    P(attrs = {
                                        style {
                                            margin(0.px, 0.px, 8.px, 0.px)
                                            color(KaihuTheme.TextSecondary)
                                            property("white-space", "pre-wrap")
                                            lineHeight("1.55")
                                        }
                                    }) {
                                        Text(announcement.message)
                                    }
                                    P(attrs = { style { margin(0.px); color(KaihuTheme.TextLight); fontSize(0.9.em) } }) {
                                        Text(buildAnnouncementAdminMeta(announcement, now))
                                    }
                                }

                                Div(attrs = {
                                    style {
                                        display(DisplayStyle.Flex)
                                        flexDirection(FlexDirection.Column)
                                        gap(10.px)
                                    minWidth(if (isMobile) 0.px else 190.px)
                                    property("width", if (isMobile) "100%" else "auto")
                                    }
                                }) {
                                    StyledButton(
                                        text = if (isBusy) "Tallennetaan..." else if (announcement.isPinned) "Poista kiinnitys" else "Kiinnitä etusivulle",
                                        enabled = busyAnnouncementId == null,
                                        backgroundColor = KaihuTheme.PrimaryTeal,
                                        onClick = {
                                            busyAnnouncementId = announcement.id
                                            scope.launch {
                                                try {
                                                    if (announcement.isPinned) {
                                                        FirebaseService.database.reference("announcements").child(announcement.id).child("isPinned").setValue(false)
                                                        com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoituksen kiinnitys poistettiin.")
                                                    } else {
                                                        clearPinnedAnnouncements(announcements, excludeId = announcement.id)
                                                        FirebaseService.database.reference("announcements").child(announcement.id).child("isPinned").setValue(true)
                                                        com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus kiinnitettiin etusivulle.")
                                                    }
                                                } catch (e: Exception) {
                                                    console.error("Ilmoituksen kiinnitys epäonnistui", e)
                                                    com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen kiinnitys epäonnistui.")
                                                } finally {
                                                    busyAnnouncementId = null
                                                }
                                            }
                                        }
                                    )

                                    StyledButton(
                                        text = "Muokkaa",
                                        enabled = busyAnnouncementId == null,
                                        backgroundColor = KaihuTheme.Grey,
                                        onClick = {
                                            title = announcement.title
                                            message = announcement.message
                                            publishPinned = announcement.isPinned
                                            editingAnnouncementId = announcement.id
                                        }
                                    )

                                    StyledButton(
                                        text = if (isBusy) "Arkistoidaan..." else "Arkistoi",
                                        enabled = busyAnnouncementId == null,
                                        backgroundColor = KaihuTheme.Grey,
                                        onClick = {
                                            busyAnnouncementId = announcement.id
                                            scope.launch {
                                                try {
                                                    FirebaseService.database.reference("announcements").child(announcement.id).setValue(
                                                        announcement.copy(
                                                            isPinned = false,
                                                            isArchived = true,
                                                            isActive = false,
                                                            updatedAt = Date.now().toLong()
                                                        )
                                                    )
                                                    if (editingAnnouncementId == announcement.id) {
                                                        title = ""
                                                        message = ""
                                                        publishPinned = false
                                                        editingAnnouncementId = null
                                                    }
                                                    com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus siirrettiin arkistoon.")
                                                } catch (e: Exception) {
                                                    console.error("Ilmoituksen arkistointi epäonnistui", e)
                                                    com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen arkistointi epäonnistui.")
                                                } finally {
                                                    busyAnnouncementId = null
                                                }
                                            }
                                        }
                                    )

                                    SmallButton(
                                        text = if (isBusy) "..." else "Poista",
                                        icon = "trash",
                                        enabled = busyAnnouncementId == null,
                                        isDanger = true,
                                        onClick = {
                                            com.kaihuoy.components.common.AppFeedback.confirm(
                                                title = "Poistetaanko ilmoitus?",
                                                message = "Tätä toimintoa ei voi perua.",
                                                confirmText = "Poista",
                                                confirmColor = KaihuTheme.Danger,
                                                onConfirm = {
                                                    busyAnnouncementId = announcement.id
                                                    scope.launch {
                                                        try {
                                                            FirebaseService.database.reference("announcements").child(announcement.id).removeValue()
                                                            if (editingAnnouncementId == announcement.id) {
                                                                title = ""
                                                                message = ""
                                                                publishPinned = false
                                                                editingAnnouncementId = null
                                                            }
                                                            com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus poistettiin.")
                                                        } catch (e: Exception) {
                                                            console.error("Ilmoituksen poisto epäonnistui", e)
                                                            com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen poisto epäonnistui.")
                                                        } finally {
                                                            busyAnnouncementId = null
                                                        }
                                                    }
                                                }
                                            )
                                        }
                                    )
                                }
                            }
                        }
                    }
                }
            }

            Div(attrs = {
                classes(AppStyles.cardShadow)
                style {
                    property("background", KaihuTheme.CardGradient)
                    borderRadius(24.px)
                    padding(if (isMobile) 20.px else 28.px)
                    property("box-shadow", AppStyles.cardShadow)
                    property("border", "1px solid ${KaihuTheme.Divider}")
                    boxSizing("border-box")
                }
            }) {
                H3(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                    Text("Arkistoidut ilmoitukset")
                }
                P(attrs = { style { margin(0.px, 0.px, 20.px, 0.px); color(KaihuTheme.TextSecondary) } }) {
                    Text("Tänne siirtyvät vanhentuneet tai manuaalisesti arkistoidut ilmoitukset. Voit muokata tai palauttaa ne uudelleen aktiivisiksi 2 viikoksi.")
                }

                if (archivedAnnouncements.isEmpty()) {
                    P(attrs = { style { color(KaihuTheme.TextSecondary); margin(0.px) } }) {
                        Text("Arkisto on vielä tyhjä.")
                    }
                } else {
                    archivedAnnouncements.forEach { announcement ->
                        val isBusy = busyAnnouncementId == announcement.id

                        Div(attrs = {
                            style {
                                padding(18.px, 0.px)
                                property("border-top", "1px solid ${KaihuTheme.Divider}")
                            }
                        }) {
                            Div(attrs = {
                                style {
                                    display(DisplayStyle.Flex)
                                    justifyContent(JustifyContent.SpaceBetween)
                                    alignItems(AlignItems.FlexStart)
                                    gap(16.px)
                                    flexWrap(FlexWrap.Wrap)
                                }
                            }) {
                                Div(attrs = { style { flex("1") } }) {
                                    AnnouncementStatusBadges(announcement, isArchived = true)

                                    H4(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                                        Text(announcement.title)
                                    }
                                    P(attrs = {
                                        style {
                                            margin(0.px, 0.px, 8.px, 0.px)
                                            color(KaihuTheme.TextSecondary)
                                            property("white-space", "pre-wrap")
                                            lineHeight("1.55")
                                        }
                                    }) {
                                        Text(announcement.message)
                                    }
                                    P(attrs = { style { margin(0.px); color(KaihuTheme.TextLight); fontSize(0.9.em) } }) {
                                        Text(buildAnnouncementAdminMeta(announcement, now))
                                    }
                                }

                                Div(attrs = {
                                    style {
                                        display(DisplayStyle.Flex)
                                        flexDirection(FlexDirection.Column)
                                        gap(10.px)
                                    minWidth(if (isMobile) 0.px else 190.px)
                                    property("width", if (isMobile) "100%" else "auto")
                                    }
                                }) {
                                    StyledButton(
                                        text = if (isBusy) "Palautetaan..." else "Palauta 2 viikoksi",
                                        enabled = busyAnnouncementId == null,
                                        backgroundColor = KaihuTheme.PrimaryTeal,
                                        onClick = {
                                            busyAnnouncementId = announcement.id
                                            scope.launch {
                                                try {
                                                    FirebaseService.database.reference("announcements").child(announcement.id).setValue(
                                                        announcement.copy(
                                                            isArchived = false,
                                                            isActive = true,
                                                            isPinned = false,
                                                            expiresAt = defaultAnnouncementExpiresAt(Date.now().toLong()),
                                                            updatedAt = Date.now().toLong()
                                                        )
                                                    )
                                                    com.kaihuoy.components.common.AppFeedback.showSuccess("Ilmoitus palautettiin aktiiviseksi 2 viikoksi.")
                                                } catch (e: Exception) {
                                                    console.error("Ilmoituksen palautus epäonnistui", e)
                                                    com.kaihuoy.components.common.AppFeedback.showError("Ilmoituksen palautus epäonnistui.")
                                                } finally {
                                                    busyAnnouncementId = null
                                                }
                                            }
                                        }
                                    )

                                    StyledButton(
                                        text = "Muokkaa",
                                        enabled = busyAnnouncementId == null,
                                        backgroundColor = KaihuTheme.Grey,
                                        onClick = {
                                            title = announcement.title
                                            message = announcement.message
                                            publishPinned = false
                                            editingAnnouncementId = announcement.id
                                        }
                                    )

                                    /*SmallButton(
                                        text = if (isBusy) "..." else "Poista",
                                        icon = "trash",
                                        enabled = busyAnnouncementId == null,
                                        isDanger = true,
                                        onClick = {
                                            AppFeedback.confirm(
                                                title = "Poistetaanko ilmoitus?",
                                                message = "Tätä toimintoa ei voi perua.",
                                                confirmText = "Poista",
                                                confirmColor = KaihuTheme.Danger,
                                                onConfirm = {
                                                    busyAnnouncementId = announcement.id
                                                    scope.launch {
                                                        try {
                                                            FirebaseService.database.reference("announcements").child(announcement.id).removeValue()
                                                            if (editingAnnouncementId == announcement.id) {
                                                                title = ""
                                                                message = ""
                                                                publishPinned = false
                                                                editingAnnouncementId = null
                                                            }
                                                            AppFeedback.showSuccess("Ilmoitus poistettiin.")
                                                        } catch (e: Exception) {
                                                            console.error("Ilmoituksen poisto epäonnistui", e)
                                                            AppFeedback.showError("Ilmoituksen poisto epäonnistui.")
                                                        } finally {
                                                            busyAnnouncementId = null
                                                        }
                                                    }
                                                }
                                            )
                                        }
                                    )*/
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun AnnouncementStatusBadges(announcement: Announcement, isArchived: Boolean) {
    val now = Date.now().toLong()
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            gap(8.px)
            flexWrap(FlexWrap.Wrap)
            marginBottom(10.px)
        }
    }) {
        if (announcement.isPinned && !isArchived) {
            AnnouncementBadge("Kiinnitetty", Color("#ECFEFF"), KaihuTheme.PrimaryTeal)
        }
        if (isArchived) {
            val archivedText = if (announcement.expiresAt > 0 && announcement.expiresAt <= now) "Vanhentunut" else "Arkistoitu"
            AnnouncementBadge(archivedText, Color("#F3F4F6"), KaihuTheme.TextSecondary)
        } else {
            AnnouncementBadge("Aktiivinen", Color("#ECFDF5"), KaihuTheme.Green)
        }
        buildAdminExpiryBadge(announcement.expiresAt, now, isArchived)?.let { badge ->
            AnnouncementBadge(badge.text, badge.background, badge.foreground)
        }
    }
}

@Composable
private fun AnnouncementBadge(text: String, background: CSSColorValue, foreground: CSSColorValue) {
    Span(attrs = {
        style {
            display(DisplayStyle.InlineBlock)
            backgroundColor(background)
            color(foreground)
            padding(6.px, 10.px)
            borderRadius(999.px)
            fontSize(0.82.em)
            fontWeight("700")
        }
    }) {
        Text(text)
    }
}

private suspend fun clearPinnedAnnouncements(announcements: List<Announcement>, excludeId: String? = null) {
    announcements.filter { it.isPinned && it.id != excludeId }.forEach { announcement ->
        FirebaseService.database.reference("announcements").child(announcement.id).child("isPinned").setValue(false)
    }
}

private fun formatAnnouncementTimestamp(timestamp: Long): String {
    if (timestamp <= 0) return "-"
    return Date(timestamp.toDouble()).toLocaleString("fi-FI")
}

private fun buildAnnouncementAdminMeta(announcement: Announcement, now: Long): String {
    val parts = mutableListOf<String>()
    parts += "Julkaistu ${formatAnnouncementTimestamp(announcement.timestamp)}"
    if (announcement.updatedAt > announcement.timestamp) {
        parts += "Päivitetty ${formatAnnouncementTimestamp(announcement.updatedAt)}"
    }
    if (announcement.expiresAt > 0) {
        parts += if (announcement.expiresAt > now) {
            "Voimassa ${formatAnnouncementTimestamp(announcement.expiresAt)} asti"
        } else {
            "Vanheni ${formatAnnouncementTimestamp(announcement.expiresAt)}"
        }
    }
    parts += announcement.createdByName.ifBlank { "KaihuOY" }
    return parts.joinToString(" · ")
}

private fun defaultAnnouncementExpiresAt(now: Long): Long = now + (14L * 24 * 60 * 60 * 1000)

private fun isAnnouncementArchived(announcement: Announcement, now: Long): Boolean {
    return announcement.isArchived || !announcement.isActive || (announcement.expiresAt > 0 && announcement.expiresAt <= now)
}

private fun announcementSortTime(announcement: Announcement): Long = maxOf(announcement.timestamp, announcement.updatedAt)

@Composable
private fun PerehdytysVastausItem(
    record: PerehdytysVastaus,
    isAdmin: Boolean,
    isSelected: Boolean,
    onClick: () -> Unit,
    onDelete: () -> Unit
) {
    val dateStr = if (record.aika > 0) Date(record.aika.toDouble()).toLocaleDateString("fi-FI") else "-"
    val vastausCount = record.vastaukset.values.count { it == "true" }
    val totalCount = record.vastaukset.size

    Div(attrs = {
        onClick { onClick() }
        style {
            padding(14.px, 18.px)
            marginBottom(8.px)
            borderRadius(12.px)
            cursor("pointer")
            backgroundColor(if (isSelected) Color("#1E3A5F") else KaihuTheme.Surface)
            property("border", "1px solid ${if (isSelected) "#2563EB" else KaihuTheme.Border}")
            property("box-shadow", if (isSelected) KaihuTheme.ShadowMd else KaihuTheme.ShadowSm)
            property("transition", "all 0.15s ease")
        }
    }) {
        Div(attrs = { style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.FlexStart); gap(8.px) } }) {
            Div(attrs = { style { flex(1) } }) {
                Div(attrs = { style { fontWeight("700"); color(KaihuTheme.TextPrimary); marginBottom(4.px) } }) {
                    Text(record.pohjaOtsikko.ifBlank { "Perehdytys" })
                }
                Div(attrs = { style { fontSize(0.88.em); color(KaihuTheme.TextSecondary); marginBottom(4.px) } }) {
                    Text(record.userName.ifBlank { "Tuntematon" })
                }
                if (record.tyomaa.isNotBlank()) {
                    Span(attrs = {
                        style {
                            display(DisplayStyle.InlineBlock); marginBottom(4.px)
                            property("background", "rgba(0,212,255,0.1)"); color(Color("#00d4ff"))
                            padding(2.px, 8.px); borderRadius(20.px)
                            fontSize(0.75.em); fontWeight("600")
                        }
                    }) { TIcon("map-pin"); Text(" ${record.tyomaa}") }
                }
                Div(attrs = { style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center) } }) {
                    Span(attrs = { style { fontSize(0.8.em); color(KaihuTheme.TextLight) } }) { Text(dateStr) }
                    if (totalCount > 0) Span(attrs = {
                        style {
                            fontSize(0.78.em); fontWeight("700"); padding(2.px, 8.px); borderRadius(20.px)
                            backgroundColor(if (vastausCount == totalCount) Color("#D8F3DC") else Color("#FFF3CD"))
                            color(if (vastausCount == totalCount) Color("#1B4332") else Color("#856404"))
                        }
                    }) { Text("$vastausCount / $totalCount") }
                }
            }
            if (isAdmin) {
                DelButton(text = "", icon = "trash", onClick = { onDelete() }, isDanger = true)
            }
        }
    }
}

@Composable
private fun PerehdytysVastausDetails(record: PerehdytysVastaus) {
    val dateStr = if (record.aika > 0) Date(record.aika.toDouble()).toLocaleString("fi-FI") else "-"
    // id -> Triple(järjestysindeksi, teksti, tyyppi)
    var pohjaKysymykset by remember(record.pohjaId) { mutableStateOf<Map<String, Triple<Int, String, String>>>(emptyMap()) }

    LaunchedEffect(record.pohjaId) {
        if (record.pohjaId.isBlank()) return@LaunchedEffect
        try {
            FirebaseService.database.reference("perehdytys_pohjat").child(record.pohjaId).valueEvents.collect { snapshot ->
                val pohja = snapshot.value<com.kaihuoy.shared.data.PerehdytysPohja>()
                pohjaKysymykset = pohja.kysymykset.mapIndexed { idx, k -> k.id to Triple(idx, k.teksti, k.tyyppi) }.toMap()
            }
        } catch (e: Exception) {
            // ei löydy pohjaa — näytetään vain "Kysymys N"
        }
    }

    Div(attrs = {
        id("vastaus-print-${record.id}")
        style {
            property("background", KaihuTheme.CardGradient); borderRadius(16.px); padding(24.px)
            property("border", "1px solid ${KaihuTheme.Border}")
            property("box-shadow", KaihuTheme.ShadowSm)
            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(20.px)
        }
    }) {
        // Otsikko, päivämäärä ja Tulosta-nappi
        Div(attrs = { style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.FlexStart) } }) {
            Div {
                H3(attrs = { style { margin(0.px, 0.px, 4.px, 0.px); color(KaihuTheme.TextPrimary) } }) {
                    Text(record.pohjaOtsikko.ifBlank { "Perehdytys" })
                }
                Div(attrs = { style { fontSize(0.85.em); color(KaihuTheme.TextLight) } }) { Text(dateStr) }
            }
            Button(attrs = {
                classes("no-print")
                onClick { printVastaus(record, pohjaKysymykset, dateStr) }
                style {
                    padding(8.px, 16.px); borderRadius(10.px); border(0.px)
                    backgroundColor(KaihuTheme.Primary); color(Color.white)
                    cursor("pointer"); fontWeight("600"); fontSize(0.88.em)
                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(6.px)
                }
            }) { TIcon("printer"); Text(" Tulosta PDF") }
        }

        // Henkilötiedot
        Div(attrs = {
            style {
                backgroundColor(KaihuTheme.Background); borderRadius(12.px); padding(16.px)
                property("border", "1px solid ${KaihuTheme.Divider}")
                display(DisplayStyle.Grid)
                property("grid-template-columns", "repeat(auto-fill, minmax(min(280px, 100%), 1fr))")
                gap(10.px)
            }
        }) {
            listOf(
                "Nimi" to record.userName,
                "Työmaa" to record.tyomaa,
                "Työnantaja" to record.employer,
                "Syntymäaika" to record.birthDate,
                "Veronumero" to record.taxNumber,
                "Puhelin" to record.phone,
                "Osoite" to record.address
            ).filter { it.second.isNotBlank() }.forEach { (label, value) ->
                Div {
                    Div(attrs = { style { fontSize(0.75.em); color(KaihuTheme.TextSecondary); fontWeight("600"); property("text-transform", "uppercase"); property("letter-spacing", "0.04em"); marginBottom(2.px) } }) { Text(label) }
                    Div(attrs = { style { fontSize(0.9.em); color(KaihuTheme.TextPrimary); fontWeight("500") } }) { Text(value) }
                }
            }
        }

        // Vastaukset
        if (record.vastaukset.isEmpty()) {
            P(attrs = { style { color(KaihuTheme.TextSecondary); margin(0.px) } }) { Text("Ei vastauksia.") }
        } else {
            val sortedEntries = record.vastaukset.entries.sortedBy { (id, _) -> pohjaKysymykset[id]?.first ?: Int.MAX_VALUE }
            val korttiTextIds = listOf("kortti_tyoturvallisuus", "kortti_tulityo", "kortti_tieturva1", "kortti_ensiapu", "kortti_vesityo", "kortti_tieturva2")
            val hasKortit = sortedEntries.any { (id, _) -> id.startsWith("kortti_") }
            var kortitRendered = false

            Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
                sortedEntries.forEachIndexed { i, (id, arvo) ->
                    if (id.startsWith("kortti_")) {
                        if (!kortitRendered) {
                            kortitRendered = true
                            // Kortit-osio: 3-sarakkeinen gridi
                            Div(attrs = {
                                style {
                                    marginTop(8.px); borderRadius(8.px)
                                    property("border", "1px solid ${KaihuTheme.Border}")
                                    property("overflow", "hidden")
                                }
                            }) {
                                Div(attrs = {
                                    style {
                                        display(DisplayStyle.Grid)
                                        property("grid-template-columns", "repeat(3, 1fr)")
                                        property("border-top", "1px solid ${KaihuTheme.Border}")
                                    }
                                }) {
                                    korttiTextIds.forEach { korttiId ->
                                        val korttiArvo = record.vastaukset[korttiId] ?: ""
                                        val korttiTeksti = pohjaKysymykset[korttiId]?.second
                                            ?: korttiId.removePrefix("kortti_").replaceFirstChar { it.uppercase() }
                                        val nimiLyhyt = korttiTeksti.removeSuffix(" – Voimassa")
                                        Div(attrs = {
                                            style {
                                                padding(10.px, 12.px)
                                                property("border-right", "1px solid ${KaihuTheme.Border}")
                                                property("border-bottom", "1px solid ${KaihuTheme.Border}")
                                            }
                                        }) {
                                            Div(attrs = { style { fontWeight("600"); fontSize(0.88.em); color(KaihuTheme.TextPrimary); marginBottom(6.px) } }) {
                                                Text(nimiLyhyt)
                                            }
                                            Div(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(6.px); fontSize(0.82.em); color(KaihuTheme.TextSecondary) } }) {
                                                Text("Voimassa")
                                                Span(attrs = { style { color(KaihuTheme.TextPrimary); fontWeight("600") } }) {
                                                    Text(if (korttiArvo.isNotBlank()) " $korttiArvo" else " —")
                                                }
                                            }
                                        }
                                    }
                                }

                                // Kirjallinen lupa — koko leveys
                                val lupaArvo = record.vastaukset["kortti_lupa"] ?: "false"
                                val lupaTeksti = pohjaKysymykset["kortti_lupa"]?.second ?: "Kirjallinen lupa taakan kiinnittämiseen / alamiehenä toimimiseen"
                                val lupaChecked = lupaArvo == "true"
                                Div(attrs = {
                                    style {
                                        display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(10.px)
                                        padding(10.px, 12.px)
                                        property("border-top", "1px solid ${KaihuTheme.Border}")
                                        backgroundColor(if (lupaChecked) Color("#0d2b1e") else Color.transparent)
                                    }
                                }) {
                                    Span(attrs = { style { fontSize(1.em); color(if (lupaChecked) Color("#10B981") else Color("#6B7280")) } }) {
                                        TIcon(if (lupaChecked) "circle-check" else "circle")
                                    }
                                    Span(attrs = { style { fontSize(0.88.em); color(KaihuTheme.TextPrimary) } }) { Text(lupaTeksti) }
                                }
                            }
                        }
                        return@forEachIndexed
                    }

                    val (_, teksti, tyyppi) = pohjaKysymykset[id] ?: Triple(i, "Kysymys ${i + 1}", "checkbox")

                    if (tyyppi == "heading") {
                        Div(attrs = {
                            style {
                                padding(10.px, 12.px); borderRadius(6.px); marginTop(8.px)
                                backgroundColor(KaihuTheme.Divider)
                                fontWeight("700"); fontSize(0.88.em)
                                color(KaihuTheme.TextSecondary)
                                property("text-transform", "uppercase")
                                property("letter-spacing", "0.06em")
                            }
                        }) { Text(teksti) }
                    } else if (tyyppi == "text") {
                        Div(attrs = {
                            style {
                                display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px)
                                padding(10.px, 12.px); borderRadius(8.px)
                                backgroundColor(KaihuTheme.Background)
                                property("border", "1px solid ${KaihuTheme.Border}")
                            }
                        }) {
                            Span(attrs = { style { fontSize(0.85.em); color(KaihuTheme.TextSecondary); fontWeight("600") } }) { Text("$teksti:") }
                            Span(attrs = { style { fontSize(0.9.em); color(KaihuTheme.TextPrimary); fontWeight("500") } }) {
                                Text(if (arvo.isNotBlank()) arvo else "—")
                            }
                        }
                    } else {
                        val checked = arvo == "true"
                        Div(attrs = {
                            style {
                                display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px)
                                padding(10.px, 12.px); borderRadius(8.px)
                                backgroundColor(if (checked) Color("#0d2b1e") else Color("#2b0d0d"))
                                property("border", "1px solid ${if (checked) "#10B98144" else "#EF444444"}")
                            }
                        }) {
                            Span(attrs = { style { fontSize(1.05.em); property("flex-shrink", "0"); color(if (checked) Color("#10B981") else Color("#EF4444")) } }) { TIcon(if (checked) "circle-check" else "circle-x") }
                            Span(attrs = { style { fontSize(0.9.em); color(KaihuTheme.TextPrimary) } }) { Text(teksti) }
                        }
                    }
                }
            }

            val checkboxCount = record.vastaukset.entries.count { (id, _) ->
                val tyyppi = pohjaKysymykset[id]?.third
                tyyppi != "heading" && tyyppi != "text"
            }
            val trueCount = record.vastaukset.entries.count { (id, arvo) ->
                val tyyppi = pohjaKysymykset[id]?.third
                arvo == "true" && tyyppi != "heading" && tyyppi != "text"
            }
            if (checkboxCount > 0) {
                Div(attrs = {
                    style {
                        padding(12.px, 16.px); borderRadius(10.px)
                        backgroundColor(KaihuTheme.Divider); textAlign("center")
                        fontWeight("700"); color(KaihuTheme.TextPrimary)
                    }
                }) {
                    Text("$trueCount / $checkboxCount kohtaa hyväksytty")
                }
            }
        }
    }
}

@Composable
private fun TabItem(text: String, icon: String, isSelected: Boolean, isMobile: Boolean, isNoPrint: Boolean = false, onClick: () -> Unit) {
    Div(attrs = {
        if (isNoPrint) classes("no-print")
        onClick { onClick() }
        style {
            padding(if (isMobile) 12.px else 8.px, if (isMobile) 12.px else 20.px)
            cursor("pointer")
            borderRadius(8.px)
            fontWeight(if (isSelected) "600" else "500")
            fontSize(0.9.em)
            property("white-space", if (isMobile) "normal" else "nowrap")
            color(if (isSelected) KaihuTheme.Primary else KaihuTheme.TextSecondary)
            backgroundColor(if (isSelected) KaihuTheme.Surface else Color.transparent)
            property("transition", "all 0.2s ease")
            textAlign("center")
            boxSizing("border-box")
            if (isSelected) property("box-shadow", KaihuTheme.ShadowSm)
        }
    }) {
        Div(attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(if (isMobile) FlexDirection.Column else FlexDirection.Row)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(6.px)
            }
        }) {
            TIcon(icon, if (isMobile) 1.2.em else 1.em)
            Span { Text(text) }
        }
    }
}

private fun printVastaus(
    record: PerehdytysVastaus,
    pohjaKysymykset: Map<String, Triple<Int, String, String>>,
    dateStr: String
) {
    val korttiTextIds = listOf("kortti_tyoturvallisuus", "kortti_tulityo", "kortti_tieturva1", "kortti_ensiapu", "kortti_vesityo", "kortti_tieturva2")
    val korttiNimet = mapOf(
        "kortti_tyoturvallisuus" to "Työturvallisuus",
        "kortti_tulityo" to "Tulityö",
        "kortti_tieturva1" to "Tieturva 1",
        "kortti_ensiapu" to "Ensiapu",
        "kortti_vesityo" to "Vesityökortti",
        "kortti_tieturva2" to "Tieturva 2"
    )

    val hasKortit = record.vastaukset.keys.any { it.startsWith("kortti_") }

    val henkilotiedotHtml = listOf(
        "Nimi" to record.userName, "Syntymäaika" to record.birthDate,
        "Työnantaja" to record.employer, "Veronumero" to record.taxNumber,
        "Osoite" to record.address, "Puh." to record.phone
    ).filter { it.second.isNotBlank() }.joinToString("") { (label, value) ->
        "<td style='border:1px solid #ccc;padding:6px 10px;'><b>$label</b><br>$value</td>"
    }.let { cells -> "<table style='width:100%;border-collapse:collapse;margin-bottom:12px;'><tr>$cells</tr></table>" }

    val kortitHtml = if (hasKortit) {
        val korttiSolut = korttiTextIds.joinToString("") { kid ->
            val arvo = record.vastaukset[kid] ?: ""
            val nimi = korttiNimet[kid] ?: kid
            "<td style='border:1px solid #ccc;padding:8px;width:33%;'><b>$nimi</b><br><span style='font-size:0.85em;'>Voimassa: ${arvo.ifBlank { "—" }}</span></td>"
        }
        val lupaArvo = record.vastaukset["kortti_lupa"] ?: "false"
        val lupaChecked = lupaArvo == "true"
        val lupaMerkki = if (lupaChecked) "☑" else "☐"
        val lupaRivi = "<tr><td colspan='3' style='border:1px solid #ccc;padding:8px;'>$lupaMerkki Kirjallinen lupa taakan kiinnittämiseen / alamiehenä toimimiseen</td></tr>"
        """
        <table style='width:100%;border-collapse:collapse;margin-bottom:12px;'>
          <tr>$korttiSolut</tr>
          $lupaRivi
        </table>
        """
    } else ""

    val vastauksetHtml = record.vastaukset.entries
        .sortedBy { (id, _) -> pohjaKysymykset[id]?.first ?: Int.MAX_VALUE }
        .filter { (id, _) -> !id.startsWith("kortti_") }
        .joinToString("") { (id, arvo) ->
            val (_, teksti, tyyppi) = pohjaKysymykset[id] ?: Triple(0, "Kohta", "checkbox")
            when (tyyppi) {
                "heading" -> "<tr><td colspan='2' style='background:#f0f0f0;padding:6px 10px;font-weight:bold;border:1px solid #ccc;'>$teksti</td></tr>"
                "text" -> "<tr><td style='border:1px solid #ccc;padding:6px 10px;'>$teksti</td><td style='border:1px solid #ccc;padding:6px 10px;'>${arvo.ifBlank { "—" }}</td></tr>"
                else -> {
                    val merkki = if (arvo == "true") "☑" else "☐"
                    "<tr><td style='border:1px solid #ccc;padding:6px 10px;'>$merkki $teksti</td><td style='border:1px solid #ccc;padding:6px 10px;'></td></tr>"
                }
            }
        }.let { rows -> if (rows.isNotBlank()) "<table style='width:100%;border-collapse:collapse;'><tbody>$rows</tbody></table>" else "" }

    val html = """
        <!DOCTYPE html><html lang='fi'><head>
        <meta charset='UTF-8'>
        <title>${record.pohjaOtsikko} — ${record.userName}</title>
        <style>
            body { font-family: Arial, sans-serif; font-size: 12px; color: #000; background: #fff; padding: 20px; margin: 0; }
            h2 { margin: 0 0 4px 0; font-size: 15px; }
            .meta { font-size: 11px; color: #666; margin-bottom: 12px; }
            table { page-break-inside: avoid; }
        </style>
        </head><body>
        <h2>${record.pohjaOtsikko.ifBlank { "Perehdytys" }}</h2>
        <div class='meta'>$dateStr${if (record.tyomaa.isNotBlank()) " &nbsp;|&nbsp; Työmaa: ${record.tyomaa}" else ""}</div>
        $henkilotiedotHtml
        $kortitHtml
        $vastauksetHtml
        <script>window.onload=function(){window.print();}</script>
        </body></html>
    """.trimIndent()

    val w = window.open("", "_blank", "width=900,height=700")
    w?.document?.open()
    w?.document?.write(html)
    w?.document?.close()
}

private data class AnnouncementBadgeInfo(
    val text: String,
    val background: CSSColorValue,
    val foreground: CSSColorValue
)

private fun buildAdminExpiryBadge(expiresAt: Long, now: Long, isArchived: Boolean): AnnouncementBadgeInfo? {
    if (expiresAt <= 0) return null
    return when {
        expiresAt <= now -> AnnouncementBadgeInfo(
            text = "Vanheni ${formatAnnouncementDate(expiresAt)}",
            background = Color("#F3F4F6"),
            foreground = KaihuTheme.TextSecondary
        )
        isArchived -> AnnouncementBadgeInfo(
            text = "Voimassa asti ${formatAnnouncementDate(expiresAt)}",
            background = Color("#EEF2FF"),
            foreground = Color("#4338CA")
        )
        expiresAt - now <= 3L * 24 * 60 * 60 * 1000 -> AnnouncementBadgeInfo(
            text = "Voimassa asti ${formatAnnouncementDate(expiresAt)}",
            background = Color("#FFF7ED"),
            foreground = Color("#C2410C")
        )
        else -> AnnouncementBadgeInfo(
            text = "Voimassa asti ${formatAnnouncementDate(expiresAt)}",
            background = Color("#EEF2FF"),
            foreground = Color("#4338CA")
        )
    }
}

private fun formatAnnouncementDate(timestamp: Long): String {
    if (timestamp <= 0) return "-"
    return Date(timestamp.toDouble()).toLocaleDateString("fi-FI")
}

@Composable
private fun TyomaatAdminTab(user: User?) {
    val scope = rememberCoroutineScope()
    var tyomaat by remember { mutableStateOf<List<Tyomaa>>(emptyList()) }
    var isLoading by remember { mutableStateOf(true) }
    var showForm by remember { mutableStateOf(false) }
    var editingTyomaa by remember { mutableStateOf<Tyomaa?>(null) }
    var nimi by remember { mutableStateOf("") }
    var osoite by remember { mutableStateOf("") }
    var isSaving by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        try {
            FirebaseService.database.reference("tyomaat").valueEvents.collect { snapshot ->
                tyomaat = snapshot.children.mapNotNull { child ->
                    try { val t = child.value<Tyomaa>(); if (t.id.isBlank()) t.copy(id = child.key ?: "") else t }
                    catch (_: Exception) { null }
                }.sortedBy { it.nimi }
                isLoading = false
            }
        } catch (e: Exception) {
            isLoading = false
        }
    }

    fun resetForm() {
        showForm = false; editingTyomaa = null; nimi = ""; osoite = ""
    }

    Div(attrs = { style { maxWidth(800.px) } }) {
        Div(attrs = {
            style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(20.px) }
        }) {
            H3(attrs = { style { margin(0.px); color(KaihuTheme.TextPrimary) } }) { Text("Työmaat") }
            if (!showForm) {
                StyledButton("+ Lisää työmaa", onClick = { showForm = true; editingTyomaa = null; nimi = ""; osoite = "" }, backgroundColor = KaihuTheme.Green)
            }
        }

        if (showForm || editingTyomaa != null) {
            Div(attrs = {
                style {
                    property("background", KaihuTheme.CardGradient); borderRadius(16.px); padding(24.px)
                    property("border", "1px solid ${KaihuTheme.Divider}"); marginBottom(24.px)
                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(12.px)
                }
            }) {
                H4(attrs = { style { margin(0.px); color(KaihuTheme.TextPrimary) } }) {
                    Text(if (editingTyomaa != null) "Muokkaa työmaata" else "Uusi työmaa")
                }
                StyledInput("Työmaan nimi *", nimi, placeholder = "Esim. Oulun satama", onValueChange = { nimi = it })
                StyledInput("Osoite (vapaaehtoinen)", osoite, placeholder = "Esim. Satamakatu 1, Oulu", onValueChange = { osoite = it })
                Div(attrs = { style { display(DisplayStyle.Flex); gap(12.px) } }) {
                    StyledButton(
                        text = if (isSaving) "Tallennetaan..." else "Tallenna",
                        enabled = !isSaving,
                        backgroundColor = KaihuTheme.Primary,
                        onClick = {
                            if (nimi.isBlank()) { com.kaihuoy.components.common.AppFeedback.showWarning("Anna työmaalle nimi."); return@StyledButton }
                            isSaving = true
                            scope.launch {
                                try {
                                    val ref = FirebaseService.database.reference("tyomaat")
                                    val id = editingTyomaa?.id ?: ref.push().key ?: Date.now().toString()
                                    ref.child(id).setValue(Tyomaa(id = id, nimi = nimi.trim(), osoite = osoite.trim(), lisattyById = user?.uid ?: "", lisatty = Date.now().toLong()))
                                    com.kaihuoy.components.common.AppFeedback.showSuccess(if (editingTyomaa != null) "Työmaa päivitetty." else "Työmaa lisätty.")
                                    resetForm()
                                } catch (e: Exception) {
                                    com.kaihuoy.components.common.AppFeedback.showError("Tallennus epäonnistui: ${e.message}")
                                } finally { isSaving = false }
                            }
                        }
                    )
                    StyledButton("Peruuta", onClick = { resetForm() }, backgroundColor = KaihuTheme.Grey)
                }
            }
        }

        if (isLoading) {
            P { Text("Ladataan...") }
        } else if (tyomaat.isEmpty()) {
            P(attrs = { style { color(KaihuTheme.TextSecondary) } }) { Text("Ei työmaita vielä. Lisää ensimmäinen.") }
        } else {
            Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(8.px) } }) {
                tyomaat.forEach { t ->
                    Div(attrs = {
                        style {
                            property("background", KaihuTheme.CardGradient); borderRadius(12.px); padding(16.px, 20.px)
                            property("border", "1px solid ${KaihuTheme.Divider}")
                            display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center)
                            gap(12.px); flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        Div {
                            Div(attrs = { style { fontWeight("600"); color(KaihuTheme.TextPrimary) } }) { Text(t.nimi) }
                            if (t.osoite.isNotBlank()) {
                                Div(attrs = { style { fontSize(0.85.em); color(KaihuTheme.TextSecondary); marginTop(2.px) } }) { Text(t.osoite) }
                            }
                        }
                        Div(attrs = { style { display(DisplayStyle.Flex); gap(8.px) } }) {
                            SmallButton("Muokkaa", onClick = { editingTyomaa = t; nimi = t.nimi; osoite = t.osoite; showForm = false })
                            SmallButton("", icon = "trash", onClick = {
                                com.kaihuoy.components.common.AppFeedback.confirm("Poistetaanko työmaa?", "Poistetaan \"${t.nimi}\"?", "Poista", confirmColor = KaihuTheme.Danger) {
                                    scope.launch {
                                        try {
                                            FirebaseService.database.reference("tyomaat").child(t.id).removeValue()
                                            com.kaihuoy.components.common.AppFeedback.showSuccess("Työmaa poistettu.")
                                        } catch (e: Exception) { com.kaihuoy.components.common.AppFeedback.showError("Poisto epäonnistui.") }
                                    }
                                }
                            }, isDanger = true)
                        }
                    }
                }
            }
        }
    }
}